import React from 'react';
import { Button } from '@mui/material';
import SignInDialog from '../SignInDialog';
import AccountMenuLink from './AccountMenuLink';
import { AppStore } from '../../../../AppStore';
import { isMobile } from 'react-device-detect';
import { AccountCircle } from '@mui/icons-material';
import './AccountLinks.less';

const AccountLinks = () => {
  const signedIn = AppStore.useState(s => s.signedIn);

  return (
    <div className="accountControls">
      {signedIn ?
          <AccountMenuLink/>
        :
          isMobile ?
            <div
              className="accountMenuLink"
              title="Account Menu"
              onClick={() => {
                AppStore.update(s => { s.signInDialog.isOpen = true; });
              }}
            >
              <AccountCircle className="accountIcon"/>
            </div>
          :
            <Button
              disableRipple={true}
              color="primary"
              variant="contained"
              className="logInButton"
              onClick={() => {
                AppStore.update(s => { s.signInDialog.isOpen = true; });
              }}
            >
              Log In
            </Button>
      }
      <SignInDialog/>
    </div>
  );
};

export default AccountLinks;